import { cn } from "@/lib/utils";
import { useStaticData } from "@/Providers/Data";
import { useEffect, useState } from "react";

export const MessageLoader = ({ className }: { className?: string }) => {
  const staticData = useStaticData();
  const [randomMessage, setRandomMessage] = useState("");
  const [LoaderMessages, setLoaderMessages] = useState<string[]>();

  useEffect(() => {
    // Select a random message from the list
    async function getLoaderMessages() {
      const result = await staticData?.getDataFromType("LoaderMessages");
      if (result.length > 0) {
        setLoaderMessages(result);
      }
    }
    getLoaderMessages();
  }, []);
  useEffect(() => {
    if (LoaderMessages?.length) {
      const randomIndex = Math.floor(Math.random() * LoaderMessages.length);
      setRandomMessage(LoaderMessages[randomIndex]);
    }
  }, [LoaderMessages]);

  return (
    <div
      className={cn(
        "w-full h-full flex flex-col items-center justify-center relative  z-[50] bg-[#FFFFFF50] filter backdrop-blur ",
        className
      )}
    >
      <div className="w-[100px] h-100 object-cover">
        <video className="w-full h-full object-cover" autoPlay loop muted>
          <source
            src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/socialLoader.webm"
            type="video/webm"
          />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="w-[40%] flex felx-wrap justify-center text-xs items-center text-[#212121] text-center">
        <p className="mt-4 text-lg font-medium">{randomMessage}</p>
      </div>
    </div>
  );
};
